var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-btns",class:{'active': _vm.shown || !_vm.isSmallScreen}},[(_vm.user && _vm.user.openid)?_c('qiyu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }